import { render, staticRenderFns } from "./FormularioAliado.vue?vue&type=template&id=3b94a1a1&scoped=true"
import script from "./FormularioAliado.vue?vue&type=script&lang=js"
export * from "./FormularioAliado.vue?vue&type=script&lang=js"
import style0 from "./FormularioAliado.vue?vue&type=style&index=0&id=3b94a1a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b94a1a1",
  null
  
)

export default component.exports